export const OperatorSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke='currentColor'
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 9.99996C12.3012 9.99996 14.1667 8.13448 14.1667 5.83329C14.1667 3.53211 12.3012 1.66663 10 1.66663C7.69885 1.66663 5.83337 3.53211 5.83337 5.83329C5.83337 8.13448 7.69885 9.99996 10 9.99996Z"

      strokeWidth="1.5"
    />
    <path
      d="M14.1667 11.6666H14.46C15.0692 11.6668 15.6574 11.8894 16.1141 12.2927C16.5708 12.696 16.8645 13.2521 16.94 13.8566L17.2658 16.46C17.2952 16.6945 17.2742 16.9326 17.2045 17.1584C17.1348 17.3842 17.0178 17.5926 16.8614 17.7698C16.7049 17.947 16.5126 18.0888 16.2971 18.186C16.0817 18.2831 15.848 18.3333 15.6117 18.3333H4.38834C4.152 18.3333 3.91834 18.2831 3.70288 18.186C3.48742 18.0888 3.29509 17.947 3.13866 17.7698C2.98222 17.5926 2.86525 17.3842 2.79551 17.1584C2.72578 16.9326 2.70487 16.6945 2.73418 16.46L3.05918 13.8566C3.13476 13.2518 3.42869 12.6954 3.8857 12.2921C4.34272 11.8888 4.93132 11.6664 5.54084 11.6666H5.83334"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
